const CURRENCY_ENDPOINT = 'https://app2.tryrino.com/api/currency';
const DEFAULT_CURRENCY = 'USD';

const CURRENCY_SIGNS = {
    USD: '$',
    EUR: '€',
    GBP: '£',
};

let currency = DEFAULT_CURRENCY;
let country = null;

const readyPromise = (async () => {
    try {
        const res = await fetch(CURRENCY_ENDPOINT);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (data && typeof data.currency === 'string' && data.currency.length > 0) {
            currency = data.currency;
        }
        if (data && typeof data.country === 'string') {
            country = data.country;
        }
    } catch (err) {
        console.error('Currency: failed to load, falling back to USD', err);
        currency = DEFAULT_CURRENCY;
    }
})();

export function getCurrency() {
    return currency;
}

export function getCountry() {
    return country;
}

export function currencySign(code) {
    const key = (code || currency || DEFAULT_CURRENCY).toUpperCase();
    const res = CURRENCY_SIGNS[key] ?? CURRENCY_SIGNS[DEFAULT_CURRENCY];
    return res;
}

export function whenCurrencyReady() {
    return readyPromise;
}
